import { createFileRoute } from "@tanstack/react-router"
import { AdminTools } from "~/components/Admin/AdminTools/AdminTools"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

import type { ReactElement } from "react"
function AdminToolsPage() {
  return (
    <>
      <CustomHead />

      <div>
        <AdminTools />
      </div>
    </>
  )
}

function AdminToolsPageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminToolsPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/tools")({
  component: AdminToolsPageWrapper,
})
